export default __webpack_public_path__ + "static/media/LAS0240.34I-30564_-26211_0.14624bc4.jpg";